"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.campaignPurposeRequiredSchema = exports.campaignPurposeSchema = exports.CAMPAIGN_PURPOSE_ERRORS = exports.CampaignPurposeFields = void 0;

var _yup = require("yup");

var _campaignPurpose = require("../../constants/campaignPurpose.constants");

var CampaignPurposeFields;
exports.CampaignPurposeFields = CampaignPurposeFields;

(function (CampaignPurposeFields) {
  CampaignPurposeFields["CampaignPurpose"] = "campaignPurpose";
  CampaignPurposeFields["OwnPurpose"] = "ownPurpose";
  CampaignPurposeFields["NumberOfRecipients"] = "numberOfRecipients";
})(CampaignPurposeFields || (exports.CampaignPurposeFields = CampaignPurposeFields = {}));

var CAMPAIGN_PURPOSE_ERRORS = {
  [CampaignPurposeFields.CampaignPurpose]: {
    required: 'Campaign purpose is required'
  },
  [CampaignPurposeFields.NumberOfRecipients]: {
    required: 'Number of recipients is required'
  },
  [CampaignPurposeFields.OwnPurpose]: {
    required: 'Custom purpose is required'
  }
};
exports.CAMPAIGN_PURPOSE_ERRORS = CAMPAIGN_PURPOSE_ERRORS;
var numberOfRecipients = (0, _yup.string)().nullable().default('').trim();
var campaignPurpose = (0, _yup.string)().nullable().default('').trim();
var ownPurpose = (0, _yup.string)().nullable().default('').trim();
var numberOfRecipientsRequired = numberOfRecipients.clone().required(CAMPAIGN_PURPOSE_ERRORS[CampaignPurposeFields.NumberOfRecipients].required);
var campaignPurposeRequired = campaignPurpose.clone().required(CAMPAIGN_PURPOSE_ERRORS[CampaignPurposeFields.CampaignPurpose].required);
var ownPurposeRequired = ownPurpose.clone().when([CampaignPurposeFields.CampaignPurpose], {
  is: function is(purpose) {
    return purpose === _campaignPurpose.CUSTOM_CAMPAIGN_PURPOSE;
  },
  then: (0, _yup.string)().required(CAMPAIGN_PURPOSE_ERRORS[CampaignPurposeFields.CampaignPurpose].required)
});
var campaignPurposeSchema = (0, _yup.object)().shape({
  [CampaignPurposeFields.CampaignPurpose]: campaignPurpose,
  [CampaignPurposeFields.OwnPurpose]: ownPurpose,
  [CampaignPurposeFields.NumberOfRecipients]: numberOfRecipients
});
exports.campaignPurposeSchema = campaignPurposeSchema;
var campaignPurposeRequiredSchema = (0, _yup.object)().shape({
  [CampaignPurposeFields.CampaignPurpose]: campaignPurposeRequired,
  [CampaignPurposeFields.OwnPurpose]: ownPurposeRequired,
  [CampaignPurposeFields.NumberOfRecipients]: numberOfRecipientsRequired
});
exports.campaignPurposeRequiredSchema = campaignPurposeRequiredSchema;